"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdditionalInsuredValidator = void 0;
const base_1 = require("./base");
const validators_1 = require("./validators");
const AdditionalInsuredValidator = (question) => {
    const { listQuestions, listSecondQuestions, listThirdQuestions, listFourthQuestions } = question.metadata;
    // first additional insured
    const internalValidators = listQuestions.reduce((map, prop) => {
        const validator = validators_1.ValidatorsFactory.createFromRaw(prop);
        map[prop.property] = validator;
        return map;
    }, {});
    const entryValidator = new base_1.BaseValidator();
    Object.keys(internalValidators).forEach(key => {
        entryValidator.addRule(item => {
            const propValidator = internalValidators[key];
            if (item)
                propValidator.validate(item[key]);
            return propValidator.errors.length ? propValidator.errors[0] : undefined;
        });
    });
    // second additional insured
    const internalSecondValidators = listSecondQuestions.reduce((map, prop) => {
        const validator = validators_1.ValidatorsFactory.createFromRaw(prop);
        map[prop.property] = validator;
        return map;
    }, {});
    const entrySecondValidator = new base_1.BaseValidator();
    Object.keys(internalSecondValidators).forEach(key => {
        entrySecondValidator.addRule(item => {
            const propValidator = internalSecondValidators[key];
            propValidator.validate(item[key]);
            return propValidator.errors.length ? propValidator.errors[0] : undefined;
        });
    });
    // third additional insured
    const internalThirdValidators = listThirdQuestions.reduce((map, prop) => {
        const validator = validators_1.ValidatorsFactory.createFromRaw(prop);
        map[prop.property] = validator;
        return map;
    }, {});
    const entryThirdValidator = new base_1.BaseValidator();
    Object.keys(internalThirdValidators).forEach(key => {
        entryThirdValidator.addRule(item => {
            const propValidator = internalThirdValidators[key];
            propValidator.validate(item[key]);
            return propValidator.errors.length ? propValidator.errors[0] : undefined;
        });
    });
    // fourth additional insured
    const internalFourthValidators = listFourthQuestions.reduce((map, prop) => {
        const validator = validators_1.ValidatorsFactory.createFromRaw(prop);
        map[prop.property] = validator;
        return map;
    }, {});
    const entryFourthValidator = new base_1.BaseValidator();
    Object.keys(internalFourthValidators).forEach(key => {
        entryFourthValidator.addRule(item => {
            const propValidator = internalFourthValidators[key];
            propValidator.validate(item[key]);
            return propValidator.errors.length ? propValidator.errors[0] : undefined;
        });
    });
    const rule = (list = []) => {
        if (!Array.isArray(list))
            return undefined;
        const errors = [];
        if (!entryValidator.validate(list[0])) {
            const firstError = entryValidator.errors[0];
            if (firstError) {
                firstError.message = `Additional Insured 1: ${firstError.message}`;
                firstError.meta = firstError.meta || {};
                firstError.meta.index = 0;
            }
            errors.push(firstError);
        }
        if (!errors.length && list[1] && !entrySecondValidator.validate(list[1])) {
            const firstError = entrySecondValidator.errors[0];
            if (firstError) {
                firstError.message = `Additional Insured 2: ${firstError.message}`;
                firstError.meta = firstError.meta || {};
                firstError.meta.index = 1;
            }
            errors.push(firstError);
        }
        if (!errors.length && list[2] && !entryThirdValidator.validate(list[2])) {
            const firstError = entryThirdValidator.errors[0];
            if (firstError) {
                firstError.message = `Additional Insured 3: ${firstError.message}`;
                firstError.meta = firstError.meta || {};
                firstError.meta.index = 2;
            }
            errors.push(firstError);
        }
        if (!errors.length && list[3] && !entryFourthValidator.validate(list[3])) {
            const firstError = entryFourthValidator.errors[0];
            if (firstError) {
                firstError.message = `Additional Insured 4: ${firstError.message}`;
                firstError.meta = firstError.meta || {};
                firstError.meta.index = 3;
            }
            errors.push(firstError);
        }
        return errors.length ? errors[0] : undefined;
    };
    return rule;
};
exports.AdditionalInsuredValidator = AdditionalInsuredValidator;
